import { LookupConstants } from 'constants/lookup';
import { createAction } from 'redux-actions';

export const fetchRentOrOwn = createAction(LookupConstants.FETCH_RENT_OR_OWN);
export const fetchEmploymentYears = createAction(LookupConstants.FETCH_EMPLOYMENT_YEARS);
export const fetchEmploymentStatus = createAction(LookupConstants.FETCH_EMPLOYMENT_STATUS);
export const getTestValuesData = createAction(LookupConstants.GET_TEST_VALUES_DATA);
